export type OpenCuePayload = {
  message: string;
  openMethod?: string;
};

export type CopilotCommandDetail = {
  type: string;
  payload: Record<string, unknown>;
};

export function dispatchCopilotCommand(detail: CopilotCommandDetail): void {
  window.dispatchEvent(
    new CustomEvent('wx-copilot-command', {
      detail,
      bubbles: true,
      composed: true,
    }),
  );
}

export function dispatchOpenCue({
  message,
  openMethod = 'external_open_cue',
}: OpenCuePayload): void {
  dispatchCopilotCommand({
    type: 'openCue',
    payload: { message, openMethod },
  });
}
